import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import Box from "../../../../components/Box";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomTextInput from "../../../../components/CustomTextInput";
import { CompanyService } from "../../../../services/CompanyService";
import { DriverService } from "../../../../services/DriverService";
import { VehicleService } from "../../../../services/VehicleService";
import { storeActivityIndicator, storeFastDriver, storeFastFirm, storeFastVehicle } from "../../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import { AmbarVoyageService } from "../../../../services/AmbarVoyageService";
import { GetAmbarVoyageListResponse, GetAmbarVoyageListResponseData } from "../../../../models/response/ambarVoyage/GetAmbarVoyageListResponse";
import { useState } from "react";
import CustomSwitch from "../../../../components/CustomSwitch";
import { GetVehicleByIdResponse } from "../../../../models/response/vehicle/GetVehicleByIdResponse";
import { ConstantService } from "../../../../services/ConstantService";
import { RootState } from "../../../../redux/store";
import { useNavigate } from "react-router-dom";

interface Props {
    voyageInformationRef: any
    voyageRefNo: string | undefined
    setVoyageRefNo: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedVehicle: CustomSingleSelectModel | undefined
    setSelectedVehicle: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedTrailer: CustomSingleSelectModel | undefined
    setSelectedTrailer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDriver: CustomSingleSelectModel | undefined
    setSelectedDriver: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedSupplier: CustomSingleSelectModel | undefined
    setSelectedSupplier: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    ambarVoyageId: string | undefined
    setAmbarVoyageId: React.Dispatch<React.SetStateAction<string | undefined>>
    voyageIsCustomActive: boolean
    voyageEnded: boolean
    setVoyageEnded: React.Dispatch<React.SetStateAction<boolean>>
    voyageHasTrackingDevice: boolean
    setVoyageHasTrackingDevice: React.Dispatch<React.SetStateAction<boolean>>
    selectedPricingVehicleType: CustomSingleSelectModel | undefined
    setSelectedPricingVehicleType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setVoyageIsCustomActive: React.Dispatch<React.SetStateAction<boolean>>
    connectVoyage: () => Promise<void>
    ambarVoyageList: GetAmbarVoyageListResponseData[]
    setAmbarVoyageList: React.Dispatch<React.SetStateAction<GetAmbarVoyageListResponseData[]>>
    ambarId: string | undefined
    /** Sefer guzergahi (15.10.2026): "Seferde ilk teslim (1. sira)" anahtari. */
    elleIlkSira: boolean
    setElleIlkSira: React.Dispatch<React.SetStateAction<boolean>>
}

const VoyageInformation = ({
    voyageInformationRef,
    setVoyageRefNo,
    voyageRefNo,
    selectedVehicle,
    setSelectedVehicle,
    selectedTrailer,
    setSelectedTrailer,
    selectedDriver,
    setSelectedDriver,
    selectedSupplier,
    setSelectedSupplier,
    ambarVoyageId,
    setAmbarVoyageId,
    setVoyageIsCustomActive,
    voyageIsCustomActive,
    voyageEnded,
    setVoyageEnded,
    voyageHasTrackingDevice,
    setVoyageHasTrackingDevice,
    selectedPricingVehicleType,
    setSelectedPricingVehicleType,
    connectVoyage,
    elleIlkSira,
    setElleIlkSira,
    ambarVoyageList,
    setAmbarVoyageList,
    ambarId
}: Props) => {
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth);
    const navigate = useNavigate();

    const dismantleVoyage = () => {
        setAmbarVoyageId(undefined);
        setSelectedDriver(undefined);
        setSelectedSupplier(undefined);
        setSelectedTrailer(undefined);
        setSelectedVehicle(undefined);
        setVoyageIsCustomActive(true);
        setVoyageEnded(false);
        setVoyageHasTrackingDevice(false);
        setVoyageRefNo('');
    }

    // Biten sefer (10.10.2026): Sefer Aktif isareti pasif, Sefere Bagla / Seferden Coz gizli.
    const seferBitti = !!ambarVoyageId && voyageEnded;
    const seferAktif = voyageIsCustomActive && !seferBitti;

    const setItemSelected = (_id: string) => {
        setAmbarVoyageList(ambarVoyageList.map(function (x) {
            if (x.ambarVoyageId == _id)
                x.isSelected = !x.isSelected;
            else
                x.isSelected = false;

            return x;
        }))
    }

    const onVoyageSelect = () => {
        var selectedItem = ambarVoyageList.find(x => x.isSelected);

        if (!selectedItem)
            return;

        setAmbarVoyageId(selectedItem.ambarVoyageId);
        setSelectedDriver(selectedItem.driverId && selectedItem.driverName ? { label: selectedItem.driverName, value: selectedItem.driverId } : undefined);
        setSelectedSupplier(selectedItem.supplierId && selectedItem.supplierName ? { label: selectedItem.supplierName, value: selectedItem.supplierId } : undefined);
        setSelectedTrailer(selectedItem.trailerId && selectedItem.trailerName ? { label: selectedItem.trailerName, value: selectedItem.trailerId } : undefined);
        setSelectedVehicle(selectedItem.vehicleId && selectedItem.vehicleName ? { label: selectedItem.vehicleName, value: selectedItem.vehicleId } : undefined);
        setVoyageRefNo(selectedItem.refNo);
        setVoyageIsCustomActive(selectedItem.isCustomActive);
        // Yeni secilen sefer: bitmemis (aktif sefer listesi); takip cihazi kaydedip yeniden acinca bilinir.
        setVoyageEnded(false);
        setVoyageHasTrackingDevice(false);

        setAmbarVoyageList([]);

        // Fiyatlanacak arac cinsi (13.10.2026, Burak): siparis kaydi bu alani sefere de yazar; bos kalirsa seferin
        // degeri silinirdi. Once seferin kendi degeri (elle verilmis olabilir), yoksa plakanin Arac Cinsi 2'si.
        if (selectedItem.pricingVehicleTypeId && selectedItem.pricingVehicleTypeName)
            setSelectedPricingVehicleType({ label: selectedItem.pricingVehicleTypeName, value: selectedItem.pricingVehicleTypeId });
        else if (selectedItem.vehicleId)
            aracCinsi2Doldur(selectedItem.vehicleId);
        else
            setSelectedPricingVehicleType(undefined);
    }

    /** Plakanin arac kartindaki Arac Cinsi 2 -> Fiyatlanacak Arac Cinsi (Sefere Bagla'da seferin degeri yoksa). */
    const aracCinsi2Doldur = async (_vehicleId: string) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: GetVehicleByIdResponse = await VehicleService.getVehicleById(_vehicleId);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setSelectedPricingVehicleType(response.data.vehicleType2Id && response.data.vehicleType2Name
                ? { label: response.data.vehicleType2Name, value: response.data.vehicleType2Id }
                : undefined);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    /** Akordiyonda acik olan sefer. Ayni anda tek sefer acik kalir. */
    const [acikSeferId, setAcikSeferId] = useState<string | undefined>(undefined);

    /** Yuk yoksa acilacak bir sey yok. */
    const seferAcKapa = (seferId: string, yukSayisi: number) => {
        if (yukSayisi === 0)
            return;

        setAcikSeferId(acikSeferId === seferId ? undefined : seferId);
    };

    /** "ISTANBUL - SARIYER - HACIOSMAN". Girilmemis olanlar atlanir. */
    const yerMetni = (il?: string | null, ilce?: string | null, semt?: string | null) =>
        [il, ilce, semt].filter(x => x && x.trim() !== '').join(' - ');

    const onVehicleChange = async (_selectedValue: CustomSingleSelectModel | undefined) => {
        setSelectedVehicle(_selectedValue);

        if (!_selectedValue)
            return;

        try {
            dispatch(storeActivityIndicator(true))

            var response: GetVehicleByIdResponse = await VehicleService.getVehicleById(_selectedValue.value);

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            if (response.data.trailerId && response.data.trailerName)
                setSelectedTrailer({ label: response.data.trailerName, value: response.data.trailerId });

            if (response.data.driverId && response.data.driverName)
                setSelectedDriver({ label: response.data.driverName, value: response.data.driverId });

            if (response.data.vehicleOwnerId && response.data.vehicleOwnerName)
                setSelectedSupplier({ label: response.data.vehicleOwnerName, value: response.data.vehicleOwnerId });

            // Fiyatlanacak arac cinsi yalniz YENI seferde arac kartindan doldurulur;
            // var olan seferde kullanicinin elle verdigi deger ezilmez.
            if (!ambarVoyageId && response.data.vehicleType2Id && response.data.vehicleType2Name)
                setSelectedPricingVehicleType({ label: response.data.vehicleType2Name, value: response.data.vehicleType2Id });
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const redirectToDevice = () => {
        localStorage.setItem("FocusedVehicleId", selectedVehicle?.value ?? '');
        localStorage.setItem("FocusedAmbarId", ambarId ?? '');
        window.open(`${window.location.origin}/map`, "_blank");
    }

    /**
     * Araç plakası yanındaki + düğmesi: üç adımlı hızlı kayıt.
     * Firma kaydedilince sürücü paneli, sürücü kaydedilince araç paneli açılır;
     * her adım bir öncekinde tanımlanan kaydı kilitli olarak kullanır.
     */
    // "Firma tanımlı" (08.10.2026): firma oluşturulmadan sürücü adımına geçilir; firma sürücü panelinde
    // tanımlı firmalardan seçilir, araç panelinde Araç Sahibi olarak dolu gelir ve değiştirilebilir.
    const hizliSurucuVeArac = (firma?: { companyId: string, name: string }) => {
        dispatch(storeFastDriver({
            relatedCompanyId: firma?.companyId,
            relatedCompanyName: firma?.name,
            onSubmit: (surucu, surucuFirmasi) => {
                dispatch(storeFastVehicle({
                    ownerCompanyId: surucuFirmasi.companyId,
                    ownerCompanyName: surucuFirmasi.name,
                    ownerEditable: !firma,
                    driverId: surucu.driverId,
                    driverName: surucu.nameSurname,
                    onSubmit: (arac, dorse) => {
                        onVehicleChange({ label: arac.plate, value: arac.vehicleId });
                        setSelectedDriver({ label: surucu.nameSurname, value: surucu.driverId });

                        if (dorse)
                            setSelectedTrailer({ label: dorse.plate, value: dorse.vehicleId });
                    }
                }))
            }
        }))
    }

    const hizliAracTanimla = () => {
        dispatch(storeFastFirm({
            isSupplier: true,
            onSubmit: (firma) => hizliSurucuVeArac({ companyId: firma.companyId, name: firma.name }),
            onFirmaTanimli: () => hizliSurucuVeArac()
        }))
    }

    return (
        <div className='containerPart' ref={voyageInformationRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <Box className="mb-10" flexDirection="row">
                        <Box flexGrow={1} justifyContent="flex-start" flexDirection="row">
                            <Box justifyContent="center">
                                <h4 className="text-black m-0">Sefer Bilgileri</h4>
                            </Box>
                            {
                        voyageRefNo && (
                            <Box justifyContent="center" ml="12px">
                                <span className="badge badge-light-primary fs-8 fw-semibold py-2 px-3">
                                    <span className="text-gray-600 me-2">Sefer No</span>{voyageRefNo}
                                </span>
                            </Box>
                        )
                    }
                            <Box justifyContent="center" ml="10px">
                                <span className="text-danger" style={{ fontSize: 12 }}>
                                    (Araç Tanımlamak için 1- Firma Tanımı, 2- Sürücü Tanımı 3- Araç Tanımı ekranı sistem tarafından otomatik açılacaktır!)
                                </span>
                            </Box>
                        </Box>
                        {
                            ambarVoyageId && (
                                <Box justifyContent="center" mr="10px">
                                <Box
                                    title={seferAktif ? 'Sefer Aktif' : (seferBitti ? 'Sefer Bitti (Pasif)' : 'Sefer Pasif')}
                                    className={seferAktif ? "p-2 bg-light-success" : "p-2 bg-light-danger"}
                                    justifyContent="center"
                                    alignItems="center"
                                    flexDirection="row"
                                    width="34px"
                                    height="34px"
                                    borderRadius="4px">
                                    <i className={seferAktif ? "fa fa-circle-play text-success" : "fa fa-circle-stop text-danger"} style={{ fontSize: 16 }} />
                                </Box>
                            </Box>
                            )
                        }
                        {
                            ambarVoyageList.length == 0 && (
                                <React.Fragment>
                                    {
                                        !seferBitti && (
                                        <React.Fragment>
                                    <Box justifyContent="center">
                                        <Box onClick={ambarVoyageId ? undefined : connectVoyage} opacity={ambarVoyageId ? "0.5" : "1"} className={"actionIcon p-2 bg-success"} justifyContent="center" flexDirection="row" borderRadius="4px">
                                            <Box mr="5px" justifyContent="center">
                                                <i className={"text-white fa fa-check"} />
                                            </Box>
                                            <Box justifyContent="center">
                                                <span style={{ fontWeight: 600 }} className="text-white">Sefere Bağla</span>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box ml="10px" justifyContent="center">
                                        <Box onClick={!ambarVoyageId ? undefined : dismantleVoyage} opacity={!ambarVoyageId ? "0.5" : "1"} className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                                            <Box mr="5px" justifyContent="center">
                                                <i className="text-white fa fa-ban" />
                                            </Box>
                                            <Box justifyContent="center">
                                                <span style={{ fontWeight: 600 }} className="text-white">Seferden Çöz</span>
                                            </Box>
                                        </Box>
                                    </Box>
                                        </React.Fragment>
                                        )
                                    }

                                    {
                                        (auth.user.user?.data.authorizedMenus?.find(x => x.menuName == "Harita") && selectedVehicle && ambarVoyageId && ambarId && voyageHasTrackingDevice) && (
                                            <Box ml={seferBitti ? undefined : "10px"} justifyContent="center">
                                                <Box onClick={redirectToDevice} className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                    <Box mr="5px" justifyContent="center">
                                                        <i className="text-white fa fa-car" />
                                                    </Box>
                                                    <Box justifyContent="center">
                                                        <span style={{ fontWeight: 600 }} className="text-white">Araç Takip</span>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </Box>

                    {
                        ambarVoyageList.length > 0 && (
                            <Box className="mb-5">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='table-responsive sefer-liste'>
                                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                                <thead>
                                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                                        <th style={{ width: 1 }}>&nbsp;</th>
                                                        <th style={{ width: 1 }}>&nbsp;</th>
                                                        <th>Sefer No</th>
                                                        <th>Araç Plaka</th>
                                                        <th>Dorse Plaka</th>
                                                        <th>Sürücü</th>
                                                        <th>Tedarikçi</th>
                                                        <th style={{ width: 110 }}>Yük Adedi</th>
                                                    </tr>
                                                </thead>
                                                <tbody className='text-gray-600 fw-bold'>
                                                    {
                                                        ambarVoyageList.length == 0 && (
                                                            <tr>
                                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                            </tr>
                                                        )
                                                    }
                                                    {
                                                        ambarVoyageList.map((item, index) => {
                                                            const yukler = item.ambars ?? [];
                                                            const acik = acikSeferId === item.ambarVoyageId;

                                                            return (
                                                                <React.Fragment key={item.ambarVoyageId}>
                                                                    <tr
                                                                        className={'sefer-satir' + (acik ? ' sefer-acik' : '')}
                                                                        onClick={() => seferAcKapa(item.ambarVoyageId, yukler.length)}
                                                                    >
                                                                        <td style={{ width: 1 }} onClick={(e) => e.stopPropagation()}>
                                                                            <div className='d-flex'>
                                                                                <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                                    <input onChange={() => setItemSelected(item.ambarVoyageId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                                                </label>
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ width: 1 }}>
                                                                            <button
                                                                                type='button'
                                                                                className='sefer-ac-dugme'
                                                                                disabled={yukler.length === 0}
                                                                                style={yukler.length === 0 ? { opacity: .35 } : undefined}
                                                                                title={yukler.length === 0 ? 'Seferde yük yok' : acik ? 'Kapat' : 'Yükleri göster'}
                                                                            >
                                                                                {acik ? '−' : '+'}
                                                                            </button>
                                                                        </td>
                                                                        <td>{item.refNo}</td>
                                                                        <td>{item.vehicleName}</td>
                                                                        <td>{item.trailerName}</td>
                                                                        <td>{item.driverName}</td>
                                                                        <td>{item.supplierName}</td>
                                                                        <td>
                                                                            {
                                                                                yukler.length > 0
                                                                                    ? <span className='badge badge-light-primary'>{yukler.length}</span>
                                                                                    : <span className='text-muted'>—</span>
                                                                            }
                                                                        </td>
                                                                    </tr>

                                                                    {
                                                                        acik && (
                                                                            <tr>
                                                                                <td className='sefer-yuk-hucre' colSpan={99}>
                                                                                    <div className='sefer-yuk-kutu'>
                                                                                        <table className='table align-middle no-footer m-0'>
                                                                                            <thead>
                                                                                                <tr className='text-start text-muted fw-bolder text-uppercase'>
                                                                                                    <th>Ref No</th>
                                                                                                    <th>Müşteri</th>
                                                                                                    <th>Yükleme Firması</th>
                                                                                                    <th>Teslim Firması</th>
                                                                                                    <th>Yükleme Yeri</th>
                                                                                                    <th>Teslim Yeri</th>
                                                                                                    <th>Sipariş Tarihi</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody className='text-gray-600 fw-bold'>
                                                                                                {
                                                                                                    yukler.map(yuk =>
                                                                                                        <tr key={yuk.ambarId}>
                                                                                                            <td>{yuk.refNo}</td>
                                                                                                            <td>{yuk.customerName}</td>
                                                                                                            <td>{yuk.loadingFirmCustomerName}</td>
                                                                                                            <td>{yuk.deliverFirmCustomerName}</td>
                                                                                                            <td>{yerMetni(yuk.loadingCountyName, yuk.loadingDistrictName, yuk.loadingNeighborhoodName)}</td>
                                                                                                            <td>{yerMetni(yuk.deliverCountyName, yuk.deliverDistrictName, yuk.deliverNeighborhoodName)}</td>
                                                                                                            <td>{yuk.orderDateStr}</td>
                                                                                                        </tr>
                                                                                                    )
                                                                                                }
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    }
                                                                </React.Fragment>
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <Box className="mt-5" flexDirection="row">
                                    <Box flexGrow={1} justifyContent="center">
                                        &nbsp;
                                    </Box>
                                    <Box justifyContent="center">
                                        <Box onClick={() => setAmbarVoyageList([])} className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                                            <Box mr="5px" justifyContent="center">
                                                <i className="text-white fa fa-times" />
                                            </Box>
                                            <Box justifyContent="center">
                                                <span style={{ fontWeight: 600 }} className="text-white">İptal</span>
                                            </Box>
                                        </Box>
                                    </Box>
                                    <Box ml="10px" justifyContent="center">
                                        <Box onClick={!ambarVoyageList.find(x => x.isSelected) ? undefined : onVoyageSelect} opacity={!ambarVoyageList.find(x => x.isSelected) ? "0.5" : "1"} className={"actionIcon p-2 bg-success"} justifyContent="center" flexDirection="row" borderRadius="4px">
                                            <Box mr="5px" justifyContent="center">
                                                <i className={"text-white fa fa-check"} />
                                            </Box>
                                            <Box justifyContent="center">
                                                <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>

                                <hr className="m-0 mt-5 mb-5" />
                            </Box>
                        )
                    }

                    <div className="row">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Araç Plaka"
                                selectedValue={selectedVehicle}
                                onChange={onVehicleChange}
                                onMenuOpen={() => VehicleService.getVehicleList(["1", "2", "4", "5"])}
                                labelName='plate'
                                valueName='vehicleId'
                                insertable={auth.user.user?.data.roles.find(x => x == "Hızlı Firma Ekleme") ? {
                                    onClick: hizliAracTanimla
                                } : undefined}
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Sürücü"
                                selectedValue={selectedDriver}
                                onChange={setSelectedDriver}
                                onMenuOpen={() => DriverService.getDriverList(selectedSupplier?.value)}
                                labelName='nameSurname'
                                valueName='driverId'
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Fiyatlanacak Araç Cinsi"
                                selectedValue={selectedPricingVehicleType}
                                onChange={setSelectedPricingVehicleType}
                                insertable={{ onSubmit: { code: 'VEHICLE_TYPE_2' } }}
                                onMenuOpen={() => ConstantService.getConstantList('VEHICLE_TYPE_2')}
                                labelName='value'
                                valueName='constantId'
                            />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Dorse Plaka"
                                selectedValue={selectedTrailer}
                                onChange={setSelectedTrailer}
                                onMenuOpen={() => VehicleService.getVehicleList(["6", "7"])}
                                labelName='plate'
                                valueName='vehicleId'
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Tedarikçi"
                                selectedValue={selectedSupplier}
                                onChange={(secilen) => {
                                    // Surucu listesi tedarikciye bagli; tedarikci degisince
                                    // onceki surucu baska firmaya ait kalabilir, temizlenir.
                                    if (secilen?.value != selectedSupplier?.value)
                                        setSelectedDriver(undefined);

                                    setSelectedSupplier(secilen);
                                }}
                                onMenuOpen={() => CompanyService.getCompanyList({ isSupplier: true })}
                                labelName='name'
                                valueName='companyId'
                            />
                        </div>

                        {/* Sefer guzergahi (15.10.2026): yalniz sefere bagliyken; Kaydet ile yazilir, seferde 1. siraya sabitlenir. */}
                        <div className="col-md-4">
                            {
                                (ambarVoyageId || voyageRefNo) && (
                                    <CustomSwitch
                                        labelText="Seferde ilk teslim (1. sıra)"
                                        isActive={elleIlkSira}
                                        setIsActive={setElleIlkSira}
                                        disabled={seferBitti}
                                        isLabelRequired={false}
                                    />
                                )
                            }
                        </div>
                    </div>

                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default VoyageInformation;